import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import classNames from 'classnames';
import IconHeart2 from 'components/icons/iconHeart2';
import { PANTONE_FABRIC_CONFIG, PDP_NAMED_FILTERS } from 'commons/constants';
import { productFilterTypes } from 'types/PDPTypes';
import FlyoutContainer from 'components/consumer/FlyoutContainer';
import FlatButtonFilters from 'components/consumer/FlatButtonFilters';
import useIsBrowser from 'hooks/useIsBrowser';
import flyoutConfig from './flyoutConfig';
const {
  pantoneFilterLabel,
  pantoneFilterSlug
} = PANTONE_FABRIC_CONFIG;
const PDPUpholsteryFiltersUI = t0 => {
  const $ = _c(59);
  const {
    className: t1,
    clearAllFiltersButton,
    fabricFavInfoToShow,
    filterCounts: t2,
    hideFlyout: t3,
    isClearanceFabricAvailable: t4,
    loading: t5,
    selectedItem,
    setSelectedItem,
    variant
  } = t0;
  const className = t1 === undefined ? "" : t1;
  let t6;
  if ($[0] !== t2) {
    t6 = t2 === undefined ? {} : t2;
    $[0] = t2;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const filterCounts = t6;
  const hideFlyout = t3 === undefined ? false : t3;
  const isClearanceFabricAvailable = t4 === undefined ? false : t4;
  const loading = t5 === undefined ? false : t5;
  let t7;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {};
    $[2] = t7;
  } else {
    t7 = $[2];
  }
  const [flyOutContent, setFlyOutContent] = useState(t7);
  const [isFlyOutVisible, setIsFlyOutVisible] = useState(false);
  const isBrowser = useIsBrowser();
  const containerRef = useRef(null);
  let t8;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <IconHeart2 />;
    $[3] = t8;
  } else {
    t8 = $[3];
  }
  let t9;
  if ($[4] !== filterCounts || $[5] !== isBrowser) {
    t9 = isBrowser && <> {filterCounts[PDP_NAMED_FILTERS.FAVORITES]}</>;
    $[4] = filterCounts;
    $[5] = isBrowser;
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  let t10;
  if ($[7] !== t9) {
    const iconHeart = <span className="flex items-center justify-center [&_svg]:w-[1.1rem] [&_svg]:h-[1.1rem] [&_svg_path]:fill-[#d86262] [&_svg_path]:stroke-[#d86262]">{t8}{t9}</span>;
    t10 = {
      label: iconHeart,
      id: PDP_NAMED_FILTERS.FAVORITES
    };
    $[7] = t9;
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      label: "Velvets",
      id: PDP_NAMED_FILTERS.VELVET
    };
    t12 = {
      label: "Pet-friendly",
      id: PDP_NAMED_FILTERS.PETFRIENDLY
    };
    t13 = {
      label: "Safeguard",
      id: PDP_NAMED_FILTERS.SAFEGUARD
    };
    t14 = {
      label: "Sustainable",
      id: PDP_NAMED_FILTERS.SUSTAINABLE
    };
    t15 = {
      label: "GREENGUARD Gold",
      id: PDP_NAMED_FILTERS.GREENGUARD
    };
    t16 = {
      label: pantoneFilterLabel,
      id: PDP_NAMED_FILTERS.PANTONE
    };
    $[9] = t11;
    $[10] = t12;
    $[11] = t13;
    $[12] = t14;
    $[13] = t15;
    $[14] = t16;
  } else {
    t11 = $[9];
    t12 = $[10];
    t13 = $[11];
    t14 = $[12];
    t15 = $[13];
    t16 = $[14];
  }
  let updatedItems;
  if ($[15] !== isClearanceFabricAvailable || $[16] !== t10) {
    updatedItems = [t10, t11, t12, t13, t14, t15, t16];
    if (isClearanceFabricAvailable) {
      let t17;
      if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = {
          label: "Clearance",
          id: PDP_NAMED_FILTERS.CLEARANCE
        };
        $[18] = t17;
      } else {
        t17 = $[18];
      }
      updatedItems.push(t17);
    }
    $[15] = isClearanceFabricAvailable;
    $[16] = t10;
    $[17] = updatedItems;
  } else {
    updatedItems = $[17];
  }
  const items = updatedItems;
  let t17;
  if ($[19] !== filterCounts || $[20] !== loading) {
    t17 = loading || isEmpty(filterCounts);
    $[19] = filterCounts;
    $[20] = loading;
    $[21] = t17;
  } else {
    t17 = $[21];
  }
  const isLoading = t17;
  let t18;
  if ($[22] !== hideFlyout || $[23] !== isLoading) {
    t18 = id => {
      if (hideFlyout || isLoading) {
        return;
      }
      if (id === pantoneFilterSlug) {
        setFlyOutContent({
          top: 0,
          ...flyoutConfig[pantoneFilterSlug]
        });
        setIsFlyOutVisible(true);
      } else {
        if (id === "pet-friendly") {
          setFlyOutContent({
            top: 0,
            ...flyoutConfig["pet-friendly"]
          });
          setIsFlyOutVisible(true);
        } else {
          if (id === "safeguard") {
            setFlyOutContent({
              top: 0,
              ...flyoutConfig.safeguard
            });
            setIsFlyOutVisible(true);
          } else {
            if (id === "greenguard-gold") {
              setFlyOutContent({
                top: 0,
                ...flyoutConfig["greenguard-gold"]
              });
              setIsFlyOutVisible(true);
            }
          }
        }
      }
    };
    $[22] = hideFlyout;
    $[23] = isLoading;
    $[24] = t18;
  } else {
    t18 = $[24];
  }
  const toggleFlyOut = t18;
  let t19;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = () => setIsFlyOutVisible(false);
    $[25] = t19;
  } else {
    t19 = $[25];
  }
  const onClose = t19;
  let t20;
  bb0: {
    if (isLoading) {
      let t21;
      if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
        t21 = [];
        $[26] = t21;
      } else {
        t21 = $[26];
      }
      t20 = t21;
      break bb0;
    }
    let t21;
    if ($[27] !== filterCounts || $[28] !== items) {
      t21 = items.filter(filterItem => {
        if (filterCounts[filterItem.id] || filterItem.id === PDP_NAMED_FILTERS.FAVORITES && filterCounts[PDP_NAMED_FILTERS.FAVORITES] !== undefined) {
          return true;
        }
        if (filterItem.id === PDP_NAMED_FILTERS.CLEARANCE) {
          return true;
        }
        return false;
      });
      $[27] = filterCounts;
      $[28] = items;
      $[29] = t21;
    } else {
      t21 = $[29];
    }
    t20 = t21;
  }
  const finalItems = t20;
  if (isLoading) {
    let t21;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
      t21 = <FlatButtonFilters loading={true} />;
      $[30] = t21;
    } else {
      t21 = $[30];
    }
    return t21;
  }
  const t21 = !!className;
  const t22 = variant === "PDPSelectUpholstery";
  let t23;
  if ($[31] !== className || $[32] !== t21 || $[33] !== t22) {
    t23 = classNames({
      [className]: t21,
      "max-[1023px]:overflow-x-scroll max-[1023px]:overflow-y-hidden max-[1023px]:ml-5 max-[1023px]:[scrollbar-width:none] max-[1023px]:[-ms-overflow-style:none] max-[1023px]:[transition:margin_.5s]": t22
    });
    $[31] = className;
    $[32] = t21;
    $[33] = t22;
    $[34] = t23;
  } else {
    t23 = $[34];
  }
  let t24;
  if ($[35] !== flyOutContent || $[36] !== hideFlyout || $[37] !== isFlyOutVisible) {
    t24 = !!isFlyOutVisible && !hideFlyout && <FlyoutContainer top={flyOutContent.top} imageUrl={flyOutContent.imageUrl} videoObj={flyOutContent.videoObj} content={flyOutContent.content} title={flyOutContent.title} onClose={onClose} isOpen={isFlyOutVisible} />;
    $[35] = flyOutContent;
    $[36] = hideFlyout;
    $[37] = isFlyOutVisible;
    $[38] = t24;
  } else {
    t24 = $[38];
  }
  let t25;
  if ($[39] !== clearAllFiltersButton) {
    t25 = <div className="hidden sm:flex flex-1 justify-end shrink-[5]">{clearAllFiltersButton}</div>;
    $[39] = clearAllFiltersButton;
    $[40] = t25;
  } else {
    t25 = $[40];
  }
  let t26;
  if ($[41] !== toggleFlyOut) {
    t26 = id_0 => {
      toggleFlyOut(id_0);
    };
    $[41] = toggleFlyOut;
    $[42] = t26;
  } else {
    t26 = $[42];
  }
  let t27;
  if ($[43] !== setSelectedItem) {
    t27 = id_1 => {
      setSelectedItem(id_1);
    };
    $[43] = setSelectedItem;
    $[44] = t27;
  } else {
    t27 = $[44];
  }
  let t28;
  if ($[45] !== finalItems || $[46] !== selectedItem || $[47] !== t25 || $[48] !== t26 || $[49] !== t27 || $[50] !== variant) {
    t28 = <FlatButtonFilters customFinalButton={t25} items={finalItems} isSelectedButtonFilled={true} onMouseEnter={t26} onMouseLeave={onClose} selectedItem={selectedItem} setSelectedItem={t27} variant={variant} />;
    $[45] = finalItems;
    $[46] = selectedItem;
    $[47] = t25;
    $[48] = t26;
    $[49] = t27;
    $[50] = variant;
    $[51] = t28;
  } else {
    t28 = $[51];
  }
  let t29;
  if ($[52] !== fabricFavInfoToShow) {
    t29 = !!fabricFavInfoToShow && <div className="text-xs font-bold max-[1023px]:pl-[22px]">{fabricFavInfoToShow}</div>;
    $[52] = fabricFavInfoToShow;
    $[53] = t29;
  } else {
    t29 = $[53];
  }
  let t30;
  if ($[54] !== t23 || $[55] !== t24 || $[56] !== t28 || $[57] !== t29) {
    t30 = <div className={t23} ref={containerRef}>{t24}{t28}{t29}</div>;
    $[54] = t23;
    $[55] = t24;
    $[56] = t28;
    $[57] = t29;
    $[58] = t30;
  } else {
    t30 = $[58];
  }
  return t30;
};
PDPUpholsteryFiltersUI.propTypes = {
  className: PropTypes.string,
  fabricFavInfoToShow: PropTypes.string,
  filterCounts: productFilterTypes,
  hideFlyout: PropTypes.bool,
  isClearanceFabricAvailable: PropTypes.bool,
  loading: PropTypes.bool,
  selectedItem: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  setSelectedItem: PropTypes.func,
  variant: PropTypes.oneOf(['PDPSelectUpholstery'])
};
export default PDPUpholsteryFiltersUI;